import ContentChoiceSetup from './ContentChoiceSetup'

export default ContentChoiceSetup
